<template>
    <Article>
        <template #header>
            <h2>Past Reunions</h2>
        </template>
        <template #content>
            <div style="max-width:600px;margin:auto;line-height:1.5rem">
                <em>Click on linked reunions to see photos and/or reunion results.</em>
                <br />
                <br />
                <strong>1947</strong>
                Merrill's Marauders Reunion, Hotel Barnum, Bridgeport, CT
                <br />
                <strong>1948</strong>
                Benjamin Franklin Hotel, Philadelphia, PA
                <br />
                <strong>1949</strong>
                Lord Baltimore Hotel, Baltimore, MD
                <br />
                <strong>1950</strong>
                Belmont Plaza Hotel, New York, NY
                <br />
                <a
                    href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1951-Reunion.pdf?alt=media"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <strong>1951</strong>
                    Belmont Plaza Hotel, New York, NY
                </a>
                <br />
                <strong>1952</strong>
                Banninger Hotel, Charlotte, NC
                <br />
                <strong>1953</strong>
                Lord Baltimore Hotel, Baltimore, MD
                <br />
                <strong>1954</strong>
                Forest Hills Inn, Franconia, NH
                <br />
                <strong>1955</strong>
                Biltmore Hotel, Atlanta, GA
                <br />
                <strong>1956</strong>
                Sylvania Hotel, Philadelphia, PA
                <br />
                <strong>1957</strong>
                Madison Hotel, Atlantic City, NJ
                <br />
                <strong>1958</strong>
                Portsmouth Hotel, Portsmouth, NH
                <br />
                <strong>1959</strong>
                Otsego Hotel, Cooperstown, NY
                <br />
                <strong>1960</strong>
                Treadway Motor Inn, St. Davids, PA
                <br />
                <strong>1961</strong>
                Ocean Forest Hotel, Myrtle Beach, SC
                <br />
                <strong>1962</strong>
                Roosevelt Motor Inn, East Meadow, NY
                <br />
                <strong>1963</strong>
                Sahara Motor Inn, Cleveland, OH
                <br />
                <strong>1964</strong>
                Dearborn Inn, Dearborn, MI
                <br />
                <strong>1965</strong>
                Treadway Motor Inn, St. Davids, PA
                <br />
                <strong>1966</strong>
                Admiralty Motor Inn, Norfolk, VA
                <br />
                <strong>1967</strong>
                Stratford Motor Inn, Stratford, CT
                <br />
                <strong>1968</strong>
                Tratford Hilton, Wakefield, MA
                <br />
                <strong>1969</strong>
                Hospitality Motor Inn, Willoughby, OH
                <br />
                <strong>1970</strong>
                Sheraton Hotel, Ft. Lauderdale, FL
                <br />
                <strong>1971</strong>
                Sheraton, Silver Spring, MD
                <br />
                <strong>1972</strong>
                Holiday Inn, King of Prussia, PA
                <br />
                <strong>1973</strong>
                Ralston Hotel, Columbus, GA
                <br />
                <strong>1974</strong>
                High Point Motor Inn, Chicopee, MA
                <br />
                <strong>1975</strong>
                Francis Marion Hotel, Charleston, SC
                <br />
                <strong>1976</strong>
                Holiday Inn, King of Prussia, PA
                <br />
                <strong>1977</strong>
                Hospitality Motor Inn, St. Louis, MO
                <br />
                <strong>1978</strong>
                Registry Resort, Scottsdale, AZ
                <br />
                <a
                    href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1979-Reunion.pdf?alt=media"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <strong>1979</strong>
                    Ferncroft Hotel, Danvers, MA
                </a>
                <br />
                <strong>1980</strong>
                Dunfey Atlanta Hotel, Atlanta, GA
                <br />
                <strong>1981</strong>
                Henry VIII Inn &amp; Lodge, Bridgeton, MO
                <br />
                <strong>1982</strong>
                Hyatt Regency Hotel, Savannah, GA
                <br />
                <strong>1983</strong>
                Sheraton Inn, Gettysburg, PA
                <br />
                <strong>1984</strong>
                Registry Resort, Scottsdale, AZ
                <br />
                <strong>1985</strong>
                Hilton South, Independence, OH
                <br />
                <strong>1986</strong>
                Radisson Plaza Hotel, Orlando, FL
                <br />
                <strong>1987</strong>
                The Monteleone, New Orleans, LA
                <br />
                <strong>1988</strong>
                The Marriott, Charlotte, NC
                <br />
                <strong>1989</strong>
                The Galt House East, Louisville, KY
                <br />
                <strong>1990</strong>
                The Desoto Hilton, Savannah, GA
                <br />
                <strong>1991</strong>
                El Paso Marriott, El Paso, TX
                <br />
                <strong>1992</strong>
                Richmond Marriott, Richmond, VA
                <br />
                <strong>1993</strong>
                Colonial Hilton Resort, Wakefield, MA
                <br />
                <strong>1994</strong>
                Hyatt Regency, Oakbrook, IL
                <br />
                <strong>1995</strong>
                Great Smokies Sun Spree Resort, Asheville, NC
                <br />
                <strong>1996</strong>
                Hyatt Regency Crystal City, Alexandria, VA
                <br />
                <strong>1997</strong>
                Ramada Plaza Gateway, Kissimmee, FL
                <br />
                <strong>1998</strong>
                Radisson In Cincinnati Airport, Cincinnati, OH
                <br />
                <strong>1999</strong>
                Nashville Airport Marriott, Nashville, TN
                <br />
                <strong>2000</strong>
                Huntsville Hilton, Huntsville, AL
                <br />
                <strong>2001</strong>
                Marriott North, Indianapolis, IN
                <br />
                <strong>2002</strong>
                Valley Forge Hilton, Valley Forge, PA
                <br />
                <strong>2003</strong>
                Wyndham Hotel, Columbus, GA
                <br />
                <strong>2004</strong>
                Sheraton Westport Plaza, St. Louis, MO
                <br />
                <strong>2005</strong>
                Hyatt Regency, Crystal City/Arlington, VA
                <br />
                <strong>2006</strong>
                Drawbridge Inn, Ft. Mitchell, KY
                <br />
                <strong>2007</strong>
                Sheraton Westport Plaza, St. Louis, MO
                <br />
                <strong>2008</strong>
                Airport Marriott, Atlanta, GA
                <br />
                <a
                    href="https://photos.app.goo.gl/mNmRgbQL3UPCbMPT6"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <strong>2009</strong>
                    Airport Holiday Inn &amp; Suites, Bloomington, MN
                </a>
                <br />
                <br />
                <strong>Reunions Hosted by Merrill's Marauders Proud Descendants</strong>
                <br />
                <a
                    href="https://photos.app.goo.gl/6wy8YaFZ6Y8tx53d6"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <strong>2010</strong>
                    Airport Holiday Inn &amp; Suites, Bloomington, MN
                </a>
                <br />
                <a
                    href="https://photos.app.goo.gl/urhLRw3sWxmtFwS68"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <strong>2011</strong>
                    Holiday Inn, Canton, OH
                </a>
                <br />
                <a
                    href="https://photos.app.goo.gl/X3JWrh6W3ka6CaSz9"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <strong>2012</strong>
                    Holiday Inn Hurstbourne, Louisville, KY
                </a>
                <br />
                <a
                    href="https://photos.app.goo.gl/3cXtXK3brBPQJ5GT6"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <strong>2013</strong>
                    Crowne Plaza Hotel &amp; Suites, Minneapolis/St. Paul, MN
                </a>
                <br />
                <a
                    href="https://photos.app.goo.gl/cC6giFZNdCySUicK7"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <strong>2014</strong>
                    Crowne Plaza Milwaukee Airport Hotel, Milwaukee, WI
                </a>
                <br />
                <strong>2015</strong>
                Dallas, TX
                <br />
                <strong>2016</strong>
                Philadelphia Embassy Suites, Philadelphia, PA
                <br />
                <strong>2017</strong>
                West Point, NY
                <br />
                <strong>2018</strong>
                New Orleans, LA
            </div>
        </template>
    </Article>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Article from '@/components/Article/Article.vue';

export default defineComponent({
    name: 'PastReunions',
    components: { Article }
});
</script>
